module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-content"
  }, _vm._l((_vm.times), function(time) {
    return _c('li', {
      key: time.id
    }, [_c('span', {
      class: {
        selected: time === _vm.selectedTime
      },
      on: {
        "click": function($event) {
          return _vm.set(time)
        }
      }
    }, [_vm._v(_vm._s(time.humanReadable))]), _vm._v(" "), _c('br')])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65b9ccb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeSelect.vue
// module id = 635
// module chunks = 2